import { darken, getContrast, lighten, rgba } from 'polished';

export const getBackgroundHoverColor = (color: string) => {
  return rgba(color, 0.1);
};

export const getHoverColor = (color: string) => {
  const darkenColor = darken(0.1, color);
  const lightenColor = lighten(0.1, color);

  return getContrast(color, darkenColor) > getContrast(color, lightenColor)
    ? darkenColor
    : lightenColor;
};
